import { Type } from 'typebox';
import { Child, FamilyClassroom, FeatureSet, Guardian, Person } from '@tadpoles/common';
const ParametersGuardian = Type.Evaluate(Type.Intersect([Guardian, Type.Required(Type.Pick(Guardian, ['actualPersonKey']))]));
const ParametersFeatureSet = Type.Evaluate(Type.Intersect([FeatureSet, Type.Object({ scope: Type.Literal('dependant') })]));
export const ParametersRelationship = Type.Object({
    guardian: ParametersGuardian,
    child: Child
});
export const ParametersPayload = Type.Object({
    person: Person,
    classrooms: Type.Array(FamilyClassroom),
    featureSets: Type.Array(ParametersFeatureSet),
    relationships: Type.Array(ParametersRelationship),
    firstEventTime: Type.Optional(Type.Number()),
    lastEventTime: Type.Optional(Type.Number()),
    farfaria: Type.Optional(Type.Unknown()),
    invitations: Type.Optional(Type.Unknown())
}, {
    additionalProperties: true
});
export class HttpParametersResource {
    #httpClient;
    constructor(httpClient) {
        this.#httpClient = httpClient;
    }
    async get(options) {
        return await this.#httpClient.get({
            path: '/family/parameters',
            payloadSchema: ParametersPayload,
            signal: options?.signal
        });
    }
}
